import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Checkbox, Typography, Dialog } from '@sm-dashboard/ui-components';

interface NewDesignAnnouncementDialogProps {
  open: boolean;
  onClose: () => void;
  onDontShowAgain: () => void;
}

const NewDesignAnnouncementDialog: React.FC<NewDesignAnnouncementDialogProps> = ({
  open,
  onClose,
  onDontShowAgain
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      onDontShowAgain();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      primaryAction={{ label: 'סגור', onClick: handleClose }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3
          }}
        >
          <Typography variant="h3" color="primary.main">
            ברוכים הבאים למערכת חב״ד למטייל
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            אנו שמחים לראותכם כאן!
          </Typography>
        </Box>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Checkbox checked={dontShowAgain} onChange={e => setDontShowAgain(e.target.checked)} label={'אל תציג שוב'} />
      </Box>
    </Dialog>
  );
};

export default NewDesignAnnouncementDialog;
